// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"StandardSelectOption_menuItem__uqmc9"};